/**
 * @generated SignedSource<<5e073338279491d44046cbba249f4abc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AidsPanelTranslateMutation$variables = {
  turnId: string;
};
export type AidsPanelTranslateMutation$data = {
  readonly translateTurn: {
    readonly translation: {
      readonly id: string;
      readonly language: string;
      readonly text: string;
    };
  };
};
export type AidsPanelTranslateMutation = {
  response: AidsPanelTranslateMutation$data;
  variables: AidsPanelTranslateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "turnId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "turnId",
        "variableName": "turnId"
      }
    ],
    "concreteType": "TranslateTurnPayload",
    "kind": "LinkedField",
    "name": "translateTurn",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Translation",
        "kind": "LinkedField",
        "name": "translation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AidsPanelTranslateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AidsPanelTranslateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "aa00ee2cb97e34ec784e72cdb27af982",
    "id": null,
    "metadata": {},
    "name": "AidsPanelTranslateMutation",
    "operationKind": "mutation",
    "text": "mutation AidsPanelTranslateMutation(\n  $turnId: ID!\n) {\n  translateTurn(turnId: $turnId) {\n    translation {\n      id\n      language\n      text\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a8ce6009644b6c90fcccb1e402cf0e4";

export default node;
